<template>
  <div class="lang-switcher" @click="toggleLocale">
    <span :class="{ active: currentLocale === 'zh-CN' }">中</span>
    <span class="divider">/</span>
    <span :class="{ active: currentLocale === 'en-US' }">EN</span>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLocaleStore } from '@/store/localeStore'

export default {
  name: 'LangSwitcher',
  setup() {
    const { locale } = useI18n()
    const localeStore = useLocaleStore()

    // 初始化: 从 store 恢复
    if (locale.value !== localeStore.locale) {
      locale.value = localeStore.locale
    }
    document.documentElement.setAttribute('lang', locale.value)

    const currentLocale = computed(() => locale.value)

    function toggleLocale() {
      const next = locale.value === 'zh-CN' ? 'en-US' : 'zh-CN'
      locale.value = next
      localeStore.setLocale(next)
      document.documentElement.setAttribute('lang', next)
    }

    return { currentLocale, toggleLocale }
  },
}
</script>

<style scoped>
.lang-switcher {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  user-select: none;
  padding: 0 8px;
}
.lang-switcher .active {
  color: #004f8e;
  font-weight: 700;
}
.lang-switcher .divider {
  margin: 0 4px;
  color: #c0c4cc;
}
.lang-switcher:hover .active {
  color: #006bb3;
}
</style>
